/**
 * 够轻松用户信息
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import * as apiIndex from '@/apis';
// import type { IUserInfo } from '@/typing/user';

// const initUserState = {} as IUserInfo;

import { type sso_info_response } from '@/apis';
interface UserState {
  userInfo: sso_info_response | null;
  
  token: string;
  transactionId: string;
  isSigned: boolean;
  isAuth: () => boolean;
  // setUserInfo: (data: IUserInfo) => void;
  // updateUserInfo: (data: Partial<IUserInfo>) => void;
  setToken: (newToken: string) => Promise<void>;
  clearToken: () => void;
  // resetUserInfo: () => void;
  setIsSigned: (isSigned: boolean) => void;
  setTransactionId: (newTransactionId: string) => void;
}

const useUserStore = create<UserState>()(
  persist(
    (set, get) => ({
      userInfo: null,
      token: '',
      transactionId: '',
      isSigned: false,

      isAuth: () => get().token !== '',

      // setUserInfo: (data) => set({ userInfo: data }),
      
      // updateUserInfo: (data) => 
      //   set((state) => ({ 
      //     userInfo: { ...state.userInfo, ...data } 
      //   })),

      setToken: async (newToken) => {
        set({ token: newToken })
        const res = await apiIndex.sso_info()
        set({ userInfo: res })
      },

      clearToken: () => {
        set({ 
          token: '',
          // userInfo: { ...initUserState }
        });
      },

      // resetUserInfo: () => set({ userInfo: { ...initUserState } }),

      setIsSigned: (isSigned) => set({ isSigned }),

      setTransactionId: (newTransactionId) => 
        set({ transactionId: newTransactionId }),
    }),
    {
      name: 'user-storage', // unique name for localStorage key
    }
  )
);

export default useUserStore